export default __webpack_public_path__ + "static/media/next-icon.581beed1.svg";